import type { FooterProps as Props } from './types';
import RichText from '../RichText';
import { cls } from '@/utils/cls';
import style from './Footer.module.scss';
export default function Footer({
  extendStyles,
  copy,
  links,
  isLightMode = false,
  footerBackgroundColor,
  footerTextColor
}: Props) {
  const customStyles = {
    backgroundColor: footerBackgroundColor || 'var(--color-background-grey)',
    color: footerTextColor || 'var(--color-white)'
  };
  const _className = cls(style.root, isLightMode ? style.light : style.dark, extendStyles);
  return <footer className={_className} style={!isLightMode ? customStyles : undefined} data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
			<RichText text={copy} className={style.copy} data-sentry-element="RichText" data-sentry-source-file="Footer.tsx" />
			<nav className={style.links}>
				{links.map((e, i) => <a key={`footer-link-${i}`} href={e.linkDestination} rel="noopener noreferrer" target="_blank">
						{e.linkText}
					</a>)}
			</nav>
		</footer>;
}